import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import numberToWords from "number-to-words";
import { getAuth } from "firebase/auth";
import {
    Box,
    Grid,
    CardContent,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Paper,
} from "@mui/material";


function Hotelinvoice() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const { documentId } = useParams();
    const [propertyId, setPropertyId] = useState(null);
    const [propData, setpropData] = useState({});

    const [bookingData, setbookingData] = useState([]);

    const [username, setusername] = useState("");
    const [custname, setcustname] = useState("");
    const [mobile, setmobile] = useState("");
    const [email, setemail] = useState("");
    const [address, setaddress] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("");
    const [gender, setgender] = useState("Male");
    const [visitpurpose, setvisitpurpose] = useState("Darshan");
    const [gstname, setgstname] = useState("");
    const [gstno, setgstno] = useState("");
    const [bookingsource, setbookingsource] = useState("Walking");
    const [documenttype, setdocumenttype] = useState("");
    const [idno, setidno] = useState("");
    const [adults, setadults] = useState("");
    const [childs, setchilds] = useState("");
    const [subtotal, setsubtotal] = useState("");
    const [taxes, settaxes] = useState("");
    const [payhistory, setpayhistory] = useState([]);
    const [amountInWords, setAmountInWords] = useState("");

    const [roomtaxable, setroomtaxable] = useState(0);
    const [roomgst, setroomgst] = useState(0);
    const [roomtotal, setroomtotal] = useState(0);

    const [servicetaxable, setservicetaxable] = useState(0);
    const [servicegst, setservicegst] = useState(0);
    const [servicetotal, setservicetotal] = useState(0);

    const [servicedamagetotal, setservicedamagetotal] = useState(0);

    const [restotaxable, setrestotaxable] = useState(0);
    const [restogst, setrestogst] = useState(0);
    const [restototal, setrestototal] = useState(0);

    const [damagetaxable, setdamagetaxable] = useState(0);
    const [damagegst, setdamagegst] = useState(0);
    const [damagetotal, setdamagetotal] = useState(0);

    const [totaltax, settotaltax] = useState(0);
    const [cgst, setcgst] = useState(0);

    useEffect(() => {
        const loadProperty = async () => {
            const auth = getAuth();
            const user = auth.currentUser;
            if (!user) return;

            const roleSnap = await getDoc(doc(db, "authroles", user.uid));
            if (!roleSnap.exists()) return;

            const pid = roleSnap.data().propertyId;

            const propSnap = await getDoc(doc(db, "properties", pid));
            if (propSnap.exists()) {
                setpropData({ ...propSnap.data() });
            }
        };

        fetchData1()
        loadProperty();
    }, []);


    const fetchData1 = async () => {
        try {
            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setbookingData(docSnap.data());

                let tax = parseFloat(docSnap.data().totalamount) * 5 / 100;

                let roomtotal = parseFloat(docSnap.data().rooamount) * parseFloat(docSnap.data().noofdays);

                // Reverse GST calculation (5%)
                let roomteax = roomtotal * 5 / 105; // GST Amount
                let taxable = roomtotal - roomteax; // Amount without GST

                setroomtotal(roomtotal.toFixed(2));
                setroomtaxable(taxable.toFixed(2));
                setroomgst(roomteax.toFixed(2));



                let servicetotal = parseFloat(docSnap.data().serviceamount);
                let serviceteax = parseFloat(servicetotal) * 5 / 100;
                let sertaxable = parseFloat(servicetotal) - parseFloat(serviceteax)
                setservicetaxable(sertaxable.toFixed(2))
                setservicegst(serviceteax.toFixed(2))
                setservicetotal(servicetotal.toFixed(2))


                let restototal = parseFloat(docSnap.data().restoamount);
                let restoteax = parseFloat(restototal) * 5 / 100;
                let restotaxable = parseFloat(restototal) - parseFloat(restoteax)
                setrestotaxable(restotaxable.toFixed(2))
                setrestogst(restoteax.toFixed(2))
                setrestototal(restototal.toFixed(2))

                let damagetotal = parseFloat(docSnap.data().damageamount);
                let damageteax = parseFloat(damagetotal) * 5 / 100;
                let damagetaxable = parseFloat(damagetotal) - parseFloat(damageteax)
                setdamagetaxable(damagetaxable.toFixed(2))
                setdamagegst(damageteax.toFixed(2))
                setdamagetotal(damagetotal.toFixed(2))

                let servciedamage = parseFloat(servicetotal) + parseFloat(damagetotal)
                setservicedamagetotal(servciedamage.toFixed(2))

                let tottax = parseFloat(roomteax);
                settotaltax(tottax.toFixed(2));
                let cgst = parseFloat(tottax) / 2;
                setcgst(cgst.toFixed(2));

                let subtotal = parseFloat(docSnap.data().totalamount) - parseFloat(tottax);
                setsubtotal(subtotal.toFixed(2));
                settaxes(tax.toFixed(2));
                const words = numberToWords.toWords(docSnap.data().totalamount);
                setAmountInWords(words);

            }



            const q1 = query(collection(db, 'payhistory'), orderBy("createdAt", "asc"), where('bookingid', '==', documentId))
            onSnapshot(q1, async (querySnapshot1) => {
                const combinedData = [];
                let paymode1 = ""
                let paymode2 = ""
                for (const doc1 of querySnapshot1.docs) {
                    const docRef1 = doc(db, "paymentmodes", doc1.data().paymode1)
                    const docSnap1 = await getDoc(docRef1)
                    if (docSnap1.exists()) {
                        paymode1 = docSnap1.data().paymode;
                    } else {
                        paymode1 = ""
                    }

                    const docRef2 = doc(db, "paymentmodes", doc1.data().paymode2)
                    const docSnap2 = await getDoc(docRef2)
                    if (docSnap2.exists()) {
                        paymode2 = docSnap2.data().paymode;
                    } else {
                        paymode2 = ""
                    }

                    const date = doc1.data().createdAt.toDate();
                    const day = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear();
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    const seconds = date.getSeconds().toString().padStart(2, '0');

                    const createdat = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

                    combinedData.push({
                        id: doc1.id,
                        data: doc1.data(),
                        paymode1: paymode1,
                        paymode2: paymode2,
                        createdat: createdat,
                    });
                }
                setpayhistory(combinedData);
            });




        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }


    const getCustData = () => {
        setcustname(bookingData.customers.custname);
        setmobile(bookingData.customers.mobile);
        setemail(bookingData.customers.email);
        setaddress(bookingData.customers.address);
        setcity(bookingData.customers.city);
        setstate(bookingData.customers.state);
        setgender(bookingData.customers.gender);
        setgstname(bookingData.customers.gstname);
        setgstno(bookingData.customers.gstno);
        setdocumenttype(bookingData.customers.documenttype);
        setidno(bookingData.customers.idno);
        setvisitpurpose(bookingData.visitpurpose);
        setbookingsource(bookingData.bookingsource);
        setadults(bookingData.adults);
        setchilds(bookingData.childs);
    }

    const updateCust = async () => {
        const customerData = {
            custname: custname,
            mobile: mobile,
            email: email,
            address: address,
            city: city,
            state: state,
            gender: gender,
            gstname: gstname,
            gstno: gstno,
            documenttype: documenttype,
            idno: idno,
            uid: userData.uid,
            createdAt: Timestamp.now(),
        };

        await updateDoc(doc(db, "reservations", documentId), {
            customers: customerData,
            bookingsource: bookingsource,
            visitpurpose: visitpurpose,
            adults: adults,
            childs: childs,
        });

        await updateDoc(doc(db, "customers", bookingData.customerId), {
            customers: customerData,
            bookingsource: bookingsource,
            visitpurpose: visitpurpose,
        });
        fetchData1()
        Toast.fire({ icon: "success", title: 'Customer Details Successfully Updated' });

    }

    const handlemobile = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 10) {
            setmobile(value);
        }

    }

    const handlePrint = () => {
        window.print();
    };

    return (
        <div>
            <Menu />
            {
                bookingData.customerId &&
                <div className="content-wrapper">
                    <section className="content mt-2">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="print-area bg-white">
                                        <CardContent style={{ borderWidth: 1, borderColor: "#4545" }}>

                                            {/* HEADER */}
                                            <Box p={1} mb={2}>
                                                <Grid className="row" alignItems="center">
                                                    <Grid className="col-sm-9" textAlign="center">
                                                        <Typography variant="h5" fontWeight="bold"
                                                            style={{ textTransform: "uppercase", color: "red" }}>{propData.hotelname}</Typography>
                                                        <Typography variant="subtitle2">
                                                            GSTIN No - {propData.hotelname}
                                                        </Typography>
                                                        <Typography>
                                                            {propData.address} {propData.city} {propData.state} {propData.pincode}
                                                            <br />
                                                            Phone: +91 {propData.mobile} | Email: {propData.email}
                                                            <br />
                                                            {/* Website: {propData.website} */}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid className="col-sm-3" textAlign="center">
                                                        <Typography variant="h4">TAX INVOICE</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            <Divider sx={{ borderColor: "black" }} />

                                            {/* INVOICE INFO */}
                                            <Grid className="row" spacing={2} mt={1}>
                                                <Grid className="col-sm-6" md={7}>
                                                    <Table size="small">
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell><b>Guest Name</b></TableCell>
                                                                <TableCell>{bookingData.customers.custname}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>Address</b></TableCell>
                                                                <TableCell>
                                                                    {bookingData.customers.address}, {bookingData.customers.city}, {bookingData.customers.state}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>Phone</b></TableCell>
                                                                <TableCell>{bookingData.customers.mobile}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>Email</b></TableCell>
                                                                <TableCell>{bookingData.customers.email}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>GST Name</b></TableCell>
                                                                <TableCell>{bookingData.customers.gstname}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>GST No</b></TableCell>
                                                                <TableCell>{bookingData.customers.gstno}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>

                                                <Grid className="col-sm-6" md={5}>
                                                    <Table size="small">
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell><b>Invoice No</b></TableCell>
                                                                <TableCell>{bookingData.invoiceno}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>Invoice Date</b></TableCell>
                                                                <TableCell>{moment().format("DD/MM/YYYY HH:mm:ss A")}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>No Of Rooms</b></TableCell>
                                                                <TableCell>{bookingData.noofrooms}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>No Of Days</b></TableCell>
                                                                <TableCell>{bookingData.noofdays}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>Check-In</b></TableCell>
                                                                <TableCell>
                                                                    {moment(bookingData.checkindate).format("DD/MM/YYYY")} {bookingData.checkintime}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>Check-Out</b></TableCell>
                                                                <TableCell>
                                                                    {moment(bookingData.checkoutdate).format("DD/MM/YYYY")} {bookingData.checkouttime}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><b>No Of Persons</b></TableCell>
                                                                <TableCell>{bookingData.adults} (A) / {bookingData.childs} (C)</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </Grid>

                                            {/* ROOMS TABLE */}
                                            <TableContainer component={Paper} sx={{ mt: 3 }}>
                                                <Table size="medium">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Room Type</TableCell>
                                                            <TableCell>Room No</TableCell>
                                                            <TableCell>Plan</TableCell>
                                                            <TableCell align="right">Rate</TableCell>
                                                            <TableCell align="right">Days</TableCell>
                                                            <TableCell align="right">Room Amount</TableCell>
                                                            <TableCell align="right">Discount</TableCell>
                                                            <TableCell align="right">Total</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {bookingData.rooms.map((item, index) => {
                                                            const amount = parseFloat(item.amount);
                                                            const total = amount * bookingData.noofdays;
                                                            const roomrate = parseFloat(item.roomrate) * bookingData.noofdays;
                                                            const discount = (amount - item.roomrate) * bookingData.noofdays;

                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell>{item.roomtypename}</TableCell>
                                                                    <TableCell>{item.roomno}</TableCell>
                                                                    <TableCell>{item.planname}</TableCell>
                                                                    <TableCell align="right">{amount.toFixed(2)}</TableCell>
                                                                    <TableCell align="right">{bookingData.noofdays}</TableCell>
                                                                    <TableCell align="right">{total.toFixed(2)}</TableCell>
                                                                    <TableCell align="right">{discount.toFixed(2)} ({item.discount}%)</TableCell>
                                                                    <TableCell align="right">{roomrate.toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            {/* TOTALS */}
                                            <Grid className="row" mt={3}>
                                                <Grid className="col-sm-6" textAlign="center">
                                                    <Typography variant="h6">BANK DETAILS</Typography>
                                                    <Typography>Bank Of Maharashtra</Typography>
                                                    <Typography>Account No : 60442386856</Typography>
                                                    <Typography>IFSC : MAHB0000743</Typography>
                                                    <Typography>Dasara Infraprojects</Typography>
                                                    <Typography>Tuljapur</Typography>
                                                </Grid>

                                                <Grid className="col-sm-6">
                                                    <Table size="small">
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>Subtotal</TableCell>
                                                                <TableCell align="right">{subtotal}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>CGST</TableCell>
                                                                <TableCell align="right">{cgst}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Grand Total</TableCell>
                                                                <TableCell align="right">{bookingData.totalamount}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Paid</TableCell>
                                                                <TableCell align="right">{bookingData.advance}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Balance</TableCell>
                                                                <TableCell align="right">{bookingData.remaining}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </Grid>

                                            <Box
                                                mt={2}
                                                py={1.5}
                                                px={2}
                                                sx={{
                                                    borderTop: "1.5px solid #4545",
                                                    borderBottom: "1.5px solid #4545",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: "14px",
                                                        letterSpacing: "0.3px",
                                                    }}
                                                >
                                                    <span style={{ color: "#E65100" }}>Total in Words :</span>{" "}
                                                    <span style={{ fontStyle: "italic", textTransform: "capitalize" }}>
                                                        {amountInWords} Rupees Only
                                                    </span>
                                                </Typography>
                                            </Box>


                                            {/* FOOTER */}
                                            <Grid className="row" mt={20}>
                                                <Grid className="col-sm-4" textAlign="center">
                                                    <Typography>Receiver Signature</Typography>
                                                </Grid>
                                                <Grid className="col-sm-4" />
                                                <Grid className="col-sm-4" textAlign="center">
                                                    <Typography>{propData.hotelname}</Typography>
                                                    <Typography>{propData.city}</Typography>
                                                </Grid>
                                            </Grid>

                                        </CardContent>
                                    </div>

                                    <center>
                                        <button className='btn btn-success' onClick={handlePrint}>Print Invoice</button>
                                    </center>
                                </div>
                                <div className="col-md-3">
                                    <div className="card card-primary card-outline">
                                        <div className="card-body box-profile">
                                            <h3 className="profile-username text-center">{bookingData.customers.custname} </h3>
                                            <p className="text-muted text-center">{bookingData.customers.mobile}</p>
                                            <center>
                                                <a style={{ marginTop: -20 }} href='#0' onClick={getCustData} data-toggle="modal" data-target="#custModal" ><i className='fa fa-edit'></i> Edit Details</a>
                                            </center>
                                            <ul className="list-group list-group-unbordered mb-3">
                                                <li className="list-group-item">
                                                    <b>Email</b> <span className="float-right">{bookingData.customers.email}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Address</b> <span className="float-right">{bookingData.customers.city} {bookingData.customers.address} {bookingData.customers.state}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Gender</b> <span className="float-right">{bookingData.customers.gender}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>GST Name</b> <span className="float-right">{bookingData.customers.gstname}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>GST No</b> <span className="float-right">{bookingData.customers.gstno}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Document Type</b> <span className="float-right">{bookingData.customers.documenttype}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>ID No</b> <span className="float-right">{bookingData.customers.idno}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Visit Purpose</b> <span className="float-right">{bookingData.visitpurpose} </span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Booking Source</b> <span className="float-right">{bookingData.bookingsource} </span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Note</b> <span className="float-right">{bookingData.note} </span>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>Visitor Photo</h6>
                                            {
                                                bookingData.visitorPhotoUrl &&
                                                <img src={bookingData.visitorPhotoUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>ID Proof Front</h6>
                                            {
                                                bookingData.idFrontUrl &&
                                                <img src={bookingData.idFrontUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>ID Proof Back</h6>
                                            {
                                                bookingData.idBackUrl &&
                                                <img src={bookingData.idBackUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>Couple Photo</h6>
                                            {
                                                bookingData.couplePhotoUrl &&
                                                <img src={bookingData.couplePhotoUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section >


                    <div className="modal fade" id="custModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Update Customer Details</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className='row'>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={custname} onChange={(e) => setcustname(e.target.value)} label="Customer Name" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={mobile} onChange={handlemobile} label="Mobile" type='tel' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' value={email} onChange={(e) => setemail(e.target.value)} label="Email" type='email' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={address} onChange={(e) => setaddress(e.target.value)} label="Address" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={city} onChange={(e) => setcity(e.target.value)} label="City" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' value={state} onChange={(e) => setstate(e.target.value)} label="State" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <FormControl className='form-control'>
                                                <InputLabel id="gender" style={{ backgroundColor: "white" }}>Gender</InputLabel>
                                                <Select labelId='gender' size='small' value={gender} onChange={(e) => setgender(e.target.value)} label="Age">
                                                    <MenuItem value='Male'>Male</MenuItem>
                                                    <MenuItem value='Female'>Female</MenuItem>
                                                    <MenuItem value='Other'>Other</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <FormControl className='form-control'>
                                                <InputLabel id="visitpurpose" style={{ backgroundColor: "white" }}>Visit Purpose</InputLabel>
                                                <Select labelId='visitpurpose' size='small' value={visitpurpose} onChange={(e) => setvisitpurpose(e.target.value)} label="Age">
                                                    <MenuItem value='Darshan'>Darshan</MenuItem>
                                                    <MenuItem value='Tourist'>Tourist</MenuItem>
                                                    <MenuItem value='Business'>Business</MenuItem>
                                                    <MenuItem value='Official'>Official</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' value={gstname} onChange={(e) => setgstname(e.target.value)} label="GST Name" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' value={gstno} onChange={(e) => setgstno(e.target.value)} label="GST No" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <FormControl className='form-control'>
                                                <InputLabel id="bookingsource" style={{ backgroundColor: "white" }}>Booking Source</InputLabel>
                                                <Select labelId='bookingsource' size='small' value={bookingsource} onChange={(e) => setbookingsource(e.target.value)} label="Age">
                                                    <MenuItem value='Walking'>Walking</MenuItem>
                                                    <MenuItem value='Website'>Website</MenuItem>
                                                    <MenuItem value='OTA'>OTA</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={documenttype} onChange={(e) => setdocumenttype(e.target.value)} label="Document Type" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={idno} onChange={(e) => setidno(e.target.value)} label="ID No" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={adults} onChange={(e) => setadults(e.target.value)} label="Adults" type='text' size='small' />
                                        </div>
                                        <div className='col-sm-3 mt-4'>
                                            <TextField className='form-control' color="secondary" value={childs} onChange={(e) => setchilds(e.target.value)} label="Childs" type='text' size='small' />
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" onClick={updateCust} >Submit</button>
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div >
            }



        </div >

    )
}
const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, // Ensure the overlay is on top
};

export default Hotelinvoice
